module.exports = __webpack_public_path__ + "static/media/leave3.4775ba18.svg";